import { Injectable } from '@angular/core';
import { Config } from 'src/app/config/config';


@Injectable({
  providedIn: 'root'
})
export class SessionhandlerService {

  constructor() { }
  private _getLocal(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      Config.logger(error);
      return null;
    }
  }
  private _saveLocal(key, value) {
    return localStorage.setItem(key, JSON.stringify(value));
  }
  private _removeLocal(key) {
    return localStorage.removeItem(key);
  }
  private _clearLocal() {
    return localStorage.clear();
  }
  private _getSession(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (error) {
      return null;
    }
  }
  private _saveSession(key, value) {
    return sessionStorage.setItem(key, JSON.stringify(value));
  }
  private _removeSession(key) {
    return sessionStorage.removeItem(key);
  }
  private _clearSession() {
    return sessionStorage.clear();
  }
  // tslint:disable-next-line:member-ordering
  public api = {
    local: {
      get: this._getLocal,
      save: this._saveLocal,
      remove: this._removeLocal,
      clear: this._clearLocal
    },
    session: {
      get: this._getSession,
      save: this._saveSession,
      remove: this._removeSession,
      clear: this._clearSession
    }
  };
}
